module.exports = __webpack_public_path__ + "img/tooltip_08-vallone-litho-calce-nero.eee77662.jpg";